import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Service } from "src/app/core/jsonapi/service";
import { environment } from "src/environment/environment";
import { DialPlan } from "../_types/dial-plan";
import { DialPlanActionTypeValue } from "../_types/dial-plan-action";

export interface DialPlanBranchNode {
  id: string;
  digit: string;
  positionX?: number;
  positionY?: number;
  actions: DialPlanActionNode[];
}

export interface DialPlanActionNode {
  id: string;
  sortOrder: number;
  actionType: DialPlanActionTypeValue;
  queueId?: string;
  extensionNumber?: string;
  application?: string;
  data?: string;
  callerId?: string;
  audioFilename?: string;
  timeoutSeconds?: number;
  maxDigits?: number;
  waitSeconds?: number;
  dtmfDigit?: string;
  ttsText?: string;
  callerIdName?: string;
  callerNumber?: string;
  startTime?: string;
  endTime?: string;
  daysOfWeek?: string;
  targetActionId?: string;
  positionX?: number;
  positionY?: number;
  branches: DialPlanBranchNode[];
}

export interface DialPlanTree {
  id: string;
  name: string;
  actions: DialPlanActionNode[];
}

@Injectable({
    providedIn: 'root',
})
export class DialPlansService extends Service<DialPlan> {
  public override type = 'dialPlans';
  public override url = 'Voip/dialPlans';

  public getTree(id: string): Observable<DialPlanTree> {
    return this.http.get<DialPlanTree>(environment.api_gw + 'voip/dialPlans/' + id + '/tree');
  }

  public deleteActionCascade(id: string): Observable<void> {
    return this.http.delete<void>(environment.api_gw + 'voip/dialPlans/actions/' + id + '/cascade');
  }

  public deleteBranchCascade(id: string): Observable<void> {
    return this.http.delete<void>(environment.api_gw + 'voip/dialPlans/branches/' + id + '/cascade');
  }
}
